import { memo, useContext } from 'react';
import { RecoverPasswordControllerHOC } from './controllers';
import { RecoverPasswordContext } from './contexts';
import {
  PageHeading,
  UserNameInputForm,
  PasswordInputForm,
  ConfirmOTP,
} from './components';
import { FEATURE } from '../../utils/feature';
import Logo from '../../assets/logo.png';
import './styles.css';

const hasFeature = FEATURE();

const PageHeadingComponent = new Map([
  [true, <PageHeading logo={Logo} />],
  [false, <></>]
]);

const InputForm = new Map([
  ['step-1', <UserNameInputForm />],
  ['step-2', <PasswordInputForm />],
]);

const RecoverPassword = memo(() => {
  const { formStep } = useContext(RecoverPasswordContext);

  return (
    <div className='recover-password-container flex flex-column flex-fill'>
      {PageHeadingComponent.get(hasFeature.PAGE_HEADING)}

      <div className='recover-password-content flex flex-fill align-items-center justify-content-center p-l-6 p-r-6'>
        {InputForm.get(formStep)}
      </div>

      <ConfirmOTP />
    </div>
  );
});

export default RecoverPasswordControllerHOC(RecoverPassword);
